export const API_PATHS = {
  auth: '/v1/auth/login',
  setting: '/v1/auth/setting',
  database: '/v1/auth/databases/private',
  faceIds: '/v1/face-ids',
  getAvatarImage: '/v1/users/avatar',
  absenceTime: '/v1/auth/time',
  threshold: '/v1/auth/threshold',
  healthFaceDb: '/v1/auth/health-facedb',
};
